import { useState, useEffect } from "react";
import { Endpoint } from "../../api/base";

interface Client {
  client_id: string;
  client_name: string;
  contacts?: Contact[];
}

interface Contact {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
}

export function useClientData() {
  const [clientList, setClientList] = useState<Client[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const res = await Endpoint.getClients();
      const emptyClient: Client = {
        client_id: "",
        client_name: "None",
      };
      const clients = [...res.data, emptyClient];
      setClientList(clients);
    } catch (err) {
      console.error("Error fetching clients:", err);
    } finally {
      setLoading(false);
    }
  };

  const getClientContacts = (clientId: string): Client | undefined => {
    return clientList.find((client) => client.client_id === clientId);
  };

  const getContactInfo = (
    clientId: string,
    contactId: string,
    field: "email" | "phone"
  ): string => {
    try {
      const client = getClientContacts(clientId);
      if (!client) return "None";

      const contact = client.contacts?.find((c) => c.id === contactId);
      if (!contact) return "";

      return contact[field] || "";
    } catch {
      return "None";
    }
  };

  return {
    clientList,
    loading,
    getClientContacts,
    getContactInfo,
  };
}
